import {
  GridColumnMenuFilter,
  GridColumnMenuProps,
  GridColumnMenuSort,
} from "@progress/kendo-react-grid";
import * as React from "react";
import { BranchViewModel } from "./BranchViewModel";
import { CarrierBranchFilterUi } from "./CarrierBranchFilterUi";

export function CarrierBranchColumnMenu(
  props: GridColumnMenuProps,
  branches: Array<BranchViewModel>
) {
  return (
    <div>
      <GridColumnMenuSort {...props} />
      <GridColumnMenuFilter
        {...props}
        expanded
        filterUI={(props) => CarrierBranchFilterUi(props, branches)}
      />
    </div>
  );
}
